import { useEffect, useState } from 'react';

export const GENERATION_ESTIMATED_SECONDS = 180;

export default function useProgressEstimate(
  startedAt?: number,
  expectedDuration: number = GENERATION_ESTIMATED_SECONDS,
) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!startedAt) return;

    const now = new Date().getTime();

    // Some people's clocks are slow and their `startedAt` would appear to be in the future
    // This is a hack to prevent the progress bar from starting negative
    const actualStartedAt = Math.min(startedAt, now);
    const interval = setInterval(
      () => setProgress(calculateProgress(actualStartedAt, expectedDuration)),
      250,
    );
    return () => clearInterval(interval);
  }, [startedAt, expectedDuration]);

  return progress;
}

function calculateProgress(startTime: number, expectedDuration: number) {
  const now = new Date().getTime();
  const secondsPassed = (now - startTime) / 1000;
  const progress = Math.round((secondsPassed / expectedDuration) * 100);

  return Math.min(progress, 100);
}
